import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Pages
import LandingPage from './pages/LandingPage';

// Calculators
import IncomeTaxCalculator from './calculators/income-tax/IncomeTaxCalculator';
import SIPCalculator from './calculators/sip/SIPCalculator';
import EMICalculator from './calculators/emi/EMICalculator';
import FDCompareCalculator from './calculators/fd-compare/FDCompareCalculator';
import PPFCalculator from './calculators/ppf/PPFCalculator';
import HRACalculator from './calculators/hra/HRACalculator';
import GratuityCalculator from './calculators/gratuity/GratuityCalculator';

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing Page */}
        <Route path="/" element={<LandingPage />} />
        
        {/* Calculator Routes - SEO friendly URLs */}
        <Route path="/calculators/income-tax" element={<IncomeTaxCalculator />} />
        <Route path="/calculators/sip" element={<SIPCalculator />} />
        <Route path="/calculators/emi" element={<EMICalculator />} />
        <Route path="/calculators/fd-compare" element={<FDCompareCalculator />} />
        <Route path="/calculators/ppf" element={<PPFCalculator />} />
        <Route path="/calculators/hra" element={<HRACalculator />} />
        <Route path="/calculators/gratuity" element={<GratuityCalculator />} />
        
        {/* Fallback - redirect to home */}
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </Router>
  );
}

export default App;
